<div class="loader" [ngClass]="{ fixed: viewType !== 'modal' }">
  <mat-spinner></mat-spinner>
</div>
